module.exports = __webpack_public_path__ + "media/bootstrap-icons/bucket-922de618.svg";